import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Grid, IconButton, Rating, TextField, Typography } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { createRating } from '../../../../../core/ratings/actions';
import { CustomButton, CustomModal } from '../../../../../components';

function RatingModal({ reviewee, reviewerId, isOpen, onClose, onSubmit }) {
  const { name, id } = reviewee;

  const dispatch = useDispatch();
  const [score, setScore] = useState(0);
  const [comment, setComment] = useState('');

  const handleClose = () => {
    setScore(0);
    setComment('');
    onClose();
  };

  const handleSubmit = () => {
    // Score is required to create a rating
    if (score === 0 || !id) return;
    const ratingData = {
      score,
      comment,
      reviewee: { id },
      reviewer: { id: reviewerId },
    };

    dispatch(createRating(ratingData));
    handleClose();
    onSubmit();
  };

  return (
    <CustomModal isOpen={isOpen} handleClose={handleClose}>
      <Grid container justifyContent="center" rowGap={1}>
        <Grid item xs={12}>
          <IconButton onClick={handleClose}>
            <CancelOutlinedIcon sx={{ fill: '#0997ba' }} />
          </IconButton>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Typography variant="body1" sx={{ fontWeight: 700 }}>
            How would you rate {name}?
          </Typography>
        </Grid>
        <Grid item xs={12} textAlign="center" mr>
          <Rating value={score} onChange={(_, newValue) => setScore(newValue)} />
        </Grid>
        <Grid item xs={12} textAlign="center" mt={2}>
          <Typography variant="body1">Write a comment:</Typography>
        </Grid>
        <Grid item xs={12} textAlign="center" px={4}>
          <TextField
            multiline
            fullWidth
            rows={5}
            onChange={(e) => setComment(e.target.value)}
            value={comment}
          />
        </Grid>
        <Grid item xs={12} textAlign="center" my={2}>
          <CustomButton variant="contained" onClick={handleSubmit}>
            Submit
          </CustomButton>
        </Grid>
      </Grid>
    </CustomModal>
  );
}

RatingModal.propTypes = {
  reviewee: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  reviewerId: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default RatingModal;
